<template>
    <nav class="side small stroke compact fixed z-50 right-0 top-0 h-full">
        <div class="navigation flex flex-col justify-center items-center h-full">
            <ul>
                <li class="selected"></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
                <li class=""></li>
            </ul>
        </div>
    </nav>
</template>

<script>
    export default {
        name: "FullPageSlideDots"
    }
</script>

<style scoped>

</style>